export function moveBetweenAnchors(anchorInitial, anchorEndpoint, relocatableElem) {
    if (!relocatableElem || !anchorEndpoint || !anchorInitial) return;

    if (window.mobileMedia && relocatableElem.previousSibling !== anchorEndpoint) {
        anchorEndpoint.after(relocatableElem);
        relocatableElem.classList.add("moved-to-anchor");
    } else if (!window.mobileMedia && relocatableElem.previousSibling !== anchorInitial) {
        anchorInitial.after(relocatableElem);
        relocatableElem.classList.remove("moved-to-anchor");
    }
}
